import { TCS } from "@/constants/TCS/TCS"

export const SupportLink = ({ className }: { className?: string }) => {
  return (
    <a
      className={`${className} text-sm text-accent underline font-semibold h-1`}
      href={`mailto:${TCS.SUPPORT_EMAIL}`}
    >
      {TCS.SUPPORT_EMAIL}
    </a>
  )
}
